<div class="lookup-popup-container">
  <div class="lookup-popup-header">
    <span class="ibc-body-text-large-bold">{{ getPopupTitle() }}</span>
  </div>

  <!-- Search -->
  <mat-form-field appearance="outline" class="mat-md w-100">
    <input
      matInput
      type="text"
      [(ngModel)]="searchTextbox"
      [placeholder]="getPlaceholderText()"
      (input)="filterLookUpList()" />
    <app-svg-icon
      *ngIf="searchTextbox"
      matSuffix
      [iconName]="'close'"
      class="dropdown-close-icon cursor"
      [isStaticSvg]="true"
      (click)="clearSearch()"
      (keydown)="onKeydown($event)">
    </app-svg-icon>
  </mat-form-field>

  <!-- Selected count + Clear -->
   <div class="selection-container" *ngIf="!readOnly">
    <div class="selected-info-bar">
      <span class="ibc-body-text-medium">
        Total Selection: {{ selectedItems.length }}
      </span>
      <div class="selection-links">
        <a
          *ngIf="showSelectAll && !isAllSelected()"
          class="ibc-body-link-text-regular  cursor"
          (click)="selectAll()">
          <u>Select All</u>
        </a>
        <a
          *ngIf="selectedItems.length"
          class="ibc-body-link-text-regular  cursor"
          (click)="clearAll()">
          <u>Clear All</u>
        </a>
      </div>
    </div>
    <div class="selected-names" *ngIf="selectedItems.length">
      <span class="ibc-body-text-medium">{{ getSelectedNames() }}</span>
    </div>
   </div>

  <!-- Table -->
  <div
    class="lookup-table ibc-border-table {{
      lookupTableDataSource.data.length === 0 ? 'no-data' : 'set-height'
    }}">
    <cdk-virtual-scroll-viewport
      itemSize="50"
      class="virtual-scroll-container"
      (scrolledIndexChange)="onScroll()">
      <mat-table
        [dataSource]="lookupTableDataSource"
        matSort
        matSortDisableClear>
        <!-- Dynamic columns -->
        <ng-container
          *ngFor="let item of lookupTableColumns"
          [matColumnDef]="item.key">
          <mat-header-cell *matHeaderCellDef>
            <ng-container *ngIf="!sortable; else sortableHeader">
              {{ item.label }}
            </ng-container>
            <ng-template #sortableHeader>
              <span class="column-header cursor">
                <span>{{ item.label }}</span>
                <span
                  mat-sort-header
                  *ngIf="lookupTableDataSource.data.length !== 0">
                  <app-svg-icon
                    [iconName]="'sort'"
                    [isStaticSvg]="true"
                    [isFrom]="'Page'"
                    [condition]="tableSortDirection"></app-svg-icon>
                </span>
              </span>
            </ng-template>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element[item.key] }}
          </mat-cell>
        </ng-container>

        <!-- Action column -->
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef>
            <span class="ibc-body-text-large">Actions</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button
            class="{{
                isSelected(element) ? 'ibc-primary-default-button' : 'ibc-secondary-default-button'
            }}"
              (click)="toggleSelection(element)"
               [disabled]="getMatchedTableRow(element)">
              {{ isSelected(element) ? 'Selected' : 'Select' }}
            </button>
          </mat-cell>
        </ng-container>

        <!-- Header row -->
        <mat-header-row
          *matHeaderRowDef="lookupTableDisplayedColumns"
          class="ibc-body-text-large-bold">
        </mat-header-row>

        <!-- Data rows -->
        <mat-row *matRowDef="let row; columns: lookupTableDisplayedColumns">
        </mat-row>
      </mat-table>
    </cdk-virtual-scroll-viewport>
     <ng-container *ngIf="lookupTableDataSource.data.length === 0">
        <div class="initial-search-text">
          {{ noResultsMessage }}
        </div>
      </ng-container>
  </div>

  <!-- Read-only popups have no selection, but still need a way out: the dialog
       is opened with disableClose. -->
  <div class="multi-lookup-popup-footer" *ngIf="readOnly">
    <div class="button-container">
      <button
        mat-stroked-button
        class="ibc-medium-button ibc-secondary-default-button cursor"
        (click)="onCancel()">
        <span class="ibc-body-text-regular">Close</span>
      </button>
    </div>
  </div>

  <div
    class="multi-lookup-popup-footer"
    *ngIf="!readOnly && lookupTableDataSource.data.length !== 0">
    <div class="button-container">
      <button mat-stroked-button  class="ibc-medium-button ibc-secondary-default-button cursor"  (click)="onCancel()">
        <span class="ibc-body-text-regular">Cancel</span>
      </button>
      <button  class="ibc-medium-button ibc-primary-default-button cursor" (click)="onConfirm()">
        <span class="ibc-body-text-regular btn-text">Confirm</span>
      </button>
    </div>
  </div>
</div>
